import { css as _css } from "@emotion/core";
import React from 'react';
import { ChevronDownIconSmall } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import * as styles from './menu-item.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MenuItem = _ref => {
  var id = _ref.id,
    label = _ref.label,
    labelClass = _ref.labelClass,
    href = _ref.href,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'column' : _ref$orientation,
    _ref$indicator = _ref.indicator,
    indicator = _ref$indicator === void 0 ? false : _ref$indicator,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'full' : _ref$size,
    _ref$expander = _ref.expander,
    expander = _ref$expander === void 0 ? 'none' : _ref$expander,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon,
    _ref$indent = _ref.indent,
    indent = _ref$indent === void 0 ? false : _ref$indent,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$isNew = _ref.isNew,
    isNew = _ref$isNew === void 0 ? false : _ref$isNew,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$onExpandClick = _ref.onExpandClick,
    onExpandClick = _ref$onExpandClick === void 0 ? null : _ref$onExpandClick;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var handleClick = event => {
    sendEvent('menu-item-click', {
      item: {
        id,
        label,
        href
      }
    });
    onClick(event);
  };
  var handleExpandClick = event => {
    event.stopPropagation();
    onExpandClick === null || onExpandClick === void 0 ? void 0 : onExpandClick(expander === 'open', id);
  };
  var isColumn = orientation === 'column';
  var isRow = !isColumn;
  var padding = isColumn;
  var leftIndicator = indicator && isColumn;
  var bottomIndicator = indicator && isRow;
  var highlight = selected && isColumn;
  var contentStyles = [padding && styles.menuContentPadding, indent && styles.indent];
  return ___EmotionJSX("div", {
    role: "none",
    id: id,
    css: /*#__PURE__*/_css([styles.menuItem, isRow && styles.sizeRow, isColumn && size === 'compact' && styles.sizeCompact, isColumn && size === 'full' && styles.sizeFull, leftIndicator && styles.indicatorLeft, bottomIndicator && styles.indicatorBottom, selected && styles.showIndicator, highlight && styles.highlight]),
    onClick: handleClick,
    onKeyUp: () => {},
    onTouchEnd: () => {}
  }, href ? ___EmotionJSX("a", {
    href: getAbsoluteUrl(href),
    css: /*#__PURE__*/_css([styles.anchor, ...contentStyles])
  }, icon ? ___EmotionJSX("span", {
    css: styles.icon
  }, icon) : null, ___EmotionJSX("span", {
    className: labelClass
  }, label)) : ___EmotionJSX("button", {
    type: "button",
    css: /*#__PURE__*/_css([styles.button, ...contentStyles])
  }, icon ? ___EmotionJSX("div", {
    css: styles.icon
  }, icon) : null, ___EmotionJSX("span", {
    className: labelClass
  }, label)), isNew && ___EmotionJSX("div", {
    css: styles.newBadge
  }, "New"), expander !== 'none' && ___EmotionJSX("button", {
    type: "button",
    css: /*#__PURE__*/_css([styles.iconButton, onExpandClick && styles.iconButtonInteractive, padding && styles.iconButtonPadding]),
    onClick: handleExpandClick,
    "aria-label": "Expand"
  }, ___EmotionJSX(ChevronDownIconSmall, {
    size: "small",
    css: /*#__PURE__*/_css([styles.icon, expander === 'open' && styles.iconExpanded])
  })));
};
export default MenuItem;